export default {
  LIST_FETCHED: 'LEGAL_FETCHED',
  LIST_LOAD: 'LEGAL_LOAD',
  ITEM_DETAIL: 'LEGAL_DETAIL',
  BUTTON_LOAD: 'LEGAL_BUTTON_LOAD',
  NEWS_LIST_FETCHED: 'LEGAL_NEWS_FETCHED',
  NEWS_LIST_LOAD: 'LEGAL_NEWS_LOAD',
  NEWS_LIST_SET: 'LEGAL_NEWS_SET',
};
